import { createFileRoute } from "@tanstack/react-router";
import { TravelPage } from "../../components/participant/travel-page";

/** `/me/travel` — every participant: their own arrival & departure, read-only (the API keys it on the login). */
export const Route = createFileRoute("/_app/me/travel/")({
	component: TravelPage,
});
